import './style.editor.scss';
import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import edit from './edit';
import { RichText, InnerBlocks } from "@wordpress/block-editor";

const attributes = {

    // Geeral 
    bubiblock_padding_caption:{
        type:'number',
        default:0
    },
    bubiblock_padding_table_caption:{
        type:'number',
        default:0
    },
    bubiblock_padding_mobile_caption:{
        type:'number',
        default:0
    },
    bubiblock_display_button_table_caption:{
        type:'boolean',
        default:true
    },
    bubiblock_display_button_mobile_caption:{
        type:'boolean',
        default:true
    },
    bubiblcok_fontfamily:{
        type: 'string',
        default:'IBM Plex Sans'+',sans-serif'
    },
    bubiblock_typography_custom:{
        type:'boolean',
        default:true
    },
    bubiblcok_fontfamily_weight:{
        type:'string',
        default:'400'
    },
    bubiblock_line_height_title:{
        type:'number',
        default:2
    },
    bubiblcok_fontfamily_descritpion:{
        type: 'string',
        default:'IBM Plex Sans'+',sans-serif'
    },
    bubiblcok_fontfamily_weight_description:{
        type:'string',
        default:'300'
    },
    bubiblock_line_height_info:{
        type:'number',
        default:2
    },
    bubiblcok_fontfamily_button:{
        type: 'string',
        default:'IBM Plex Sans'+',sans-serif'
    },
    bubiblcok_fontfamily_weight_button:{
        type:'string',
        default:'400'
    },
    height_slider:{
        type:'number',
        default:500
    },
    df_height_slider_auto:{
        type:'bolean',
        default:false
    },
    df_resp:{
        type: 'string',
        default:'desktop'
    },
    height_slider_table:{
        type:'number',
        default:400
    },
    height_slider_mobile:{
        type:'number',
        default:300
    },
    bubiblock_full_slider:{
        type:'boolean',
        default:false
    },
    df_interval_slider:{
        type:'string',
        default:'0'
    },
    bubiblock_speed_flip_slider:{
        type:'number',
        default:3
    },
   
    df_pause_slider:{
        type:'string',
        default:'hover'
    },
    df_effect_slider:{
        type:'string',
        default:'df-slider-slide'
    },
    bubiblock_show_slider_desktop:{
        type:'boolean',
        default:true
    },
    bubiblock_show_slider_table:{
        type:'boolean',
        default:true
    },
    bubiblock_show_slider_mobile:{
        type:'boolean',
        default:true
    },
    bubiblock_carousle_touch:{
        type:'boolean',
        default:true
    },
    bubi_block_content_slider:{
        type:'string',
        default:'bubiblock-content-slider'
    },
    bubiblock_padding_block_slider:{
        type:'number',
        default:15
    },
    bubiblock_padding_b_block_slider:{
        type:'number',
        default:15
    },
    bubiblock_padding_block_slider_table:{
        type:'number',
        default:10
    },
    bubiblock_padding_b_block_slider_table:{
        type:'number',
        default:10
    },
    bubiblock_padding_block_slider_mobile:{
        type:'number',
        default:5
    },
    bubiblock_padding_b_block_slider_mobile:{
        type:'number',
        default:5
    },
    bubiblock_background_color_block_slider:{
        type:'string',
    },
    bubiopacityblock_slider:{
        type:'number',
        default:1
    },
    df_arrow_slider:{
        type:'string',
        default:'df-arrow-true'
    },
    df_arrow_slider_table:{
        type:'string',
        default:'df-arrow-table-true'
    },
    df_arrow_slider_mobile:{
        type:'string',
        default:'df-arrow-mobile-false'
    },
    bubiblock_padding_slider:{
        type:'number',
        default:0
    },
    bubiblock_padding_table_slider:{
        type:'number',
        default:0
    },
    bubiblock_padding_b_table_slider:{
        type:'number',
        default:0
    },
    bubiblock_padding_mobile_slider:{
        type:'number',
        default:0
    },
    bubiblock_padding_b_mobile_slider:{
        type:'number',
        default:0
    },
    bubiblock_padding_b_slider:{
        type:'number',
        default:.0
    },
    bubiblock_radius_slider:{
        type:'number',
        default:.0
    },
    bubiblock_background_color_slider:{
        type:'string',
    },
    df_arrow_slider_type:{
        type:'string',
        default:'bubi-arrow-right-alt2'
    },
    df_arrow_border_solid_slider:{
        type:'number',
        default:0
    },
    bubiblock_id_slider:{
        type:'string',
        default:'one'
    },
    df_color_arrow:{
        type:'string',
    },
    bubiopacityarrow:{
        type: 'number',
        default:.5
    },
    bubiopacityhoverarrow:{
        type: 'number',
        default:1
    },
    df_padding_arrow:{
        type:'number',
        default:0
    },
    df_radius_arrow:{
        type:'number',
        default:0
    },
    df_size_arrow:{
        type:'number',
        default:30
    },
    df_size_arrow_table:{
        type:'number',
        default:16
    },
    df_size_arrow_mobile:{
        type:'number',
        default:16
    },
    bubi_marginarrow:{
        type:'number',
        default:0
    },
    df_dot_slider:{
        type:'string',
        default:'df-dot-true'
    },
    df_dot_slider_table:{
        type:'string',
        default:'df-dot-table-true'
    },
    df_dot_slider_mobile:{
        type:'string',
        default:'df-dot-mobile-false'
    },
    df_dot_slider_type:{
        type:'string',
        default:'df-dot-linear'
    },
    bubi_arrow_position :{
        type:'string',
        default:'arrowcenter' 
    },
    df_width_dot:{
        type:'number',
        default: 20
    },
    df_height_dot:{
        type:'number',
        default: 3
    },
    bubiblock_height_dot_active_enable:{
        type:'boolean',
        default:false
    },
    bubiblock_height_dot_active:{
        type:'number',
        default: 8
    },
    bubiblock_progress_dot_enable:{
        type:'boolean',
        default:false
    },
    df_color_progress_dot:{
        type:'string',
        default:'#007cba' 
    },
    df_spacing_dot:{
        type:'number',
        default: 3
    },
    df_bottom_dot:{
        type:'number',
        default: 10
    },
    df_color_dot:{
        type:'string',
        default:'#fff'
    },
    // Slider 1
    df_slider_chose_1:{
        type: 'string',
        default: 'df-slider-color-1'
    },
    id: {
        type: 'number'
    },
    alt: {
        type: 'string',
        source: 'attribute',
        selector: 'img',
        attribute: 'alt',
        default: ''
    },
    url: {
        type: 'string',
        source: 'attribute',
        selector: 'img',
        attribute: 'src',
    },
    df_cover_img1:{
        type: 'string',
        default: 'cover',
    },
    df_focalPoint_img_1: {
        type: 'number',
        default:50
    },
    df_focalPoint_y_img_1: {
        type: 'number',
        default:50
    },
    df_background_color_slider_1:{
        type: 'string',
    }, 
    effectcaption1: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectcaption1:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectcaption1:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectcaption1:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    margin_bottom_caption1: {
        type: 'number',
        default:80
    },
    margin_bottom_table_caption1: {
        type: 'number',
        default:25
    },
    margin_bottom_mobile_caption1: {
        type: 'number',
        default:15
    },
    df_info_table_slider_1:{
        type:'string',
        default:'df-caption-table-true'
    },
    df_info_mobile_slider_1:{
        type:'string',
        default:'df-caption-mobile-false'
    },
    margin_bottom_info1: {
        type: 'number',
        default:40
    },
    margin_bottom_table_info1: {
        type: 'number',
        default:30
    },
    margin_bottom_mobile_info1: {
        type: 'number',
        default:10
    },
    margin_bottom_button1: {
        type: 'number',
        default:5
    },
    margin_bottom_table_button1: {
        type: 'number',
        default:5
    },
    margin_bottom_mobile_button1: {
        type: 'number',
        default:5
    },
    effectinfo1: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectinfo1:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectinfo1:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectinfo1:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    effectbutton1: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectbutton1:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectbutton1:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectbutton1:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    title1: {
        type: 'string',
        source: 'html',
        selector: 'h4'
    },
    fontsizetitle1:{
        type: 'number',
        default:24
    },
    fontsizetitle1table:{
        type: 'number',
        default:22
    },
    fontsizetitle1mobile:{
        type: 'number',
        default:18
    },
    info1: {
        type: 'string',
        source: 'html',
        selector: 'p'
    },
    fontsizeinfo1:{
        type: 'number',
        default:16
    },
    fontsizeinfo1table:{
        type: 'number',
        default:16
    },
    fontsizeinfo1mobile:{
        type: 'number',
        default:16
    },
    alignment_title1: {
        type: 'string',
        default: 'left'
    },
    alignment_info1: {
        type: 'string',
        default: 'left'
    },
    button1: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__link'
    },
    fontsizebutton1:{
        type: 'number',
        default:15
    },
    fontsizebutton1table:{
        type: 'number',
        default:15
    },
    fontsizebutton1mobile:{
        type: 'number',
        default:15
    },
    alignment_button1: {
        type: 'string',
        default: 'right'
    },
    padding_link_button1:{
        type: 'number',
        default:8
    },
    padding_right_link_button1:{
        type: 'number',
        default:20
    },
    border_radius_top_left_link_button1:{
        type: 'number',
        default:4
    },
    border_radius_top_right_link_button1:{
        type: 'number',
        default:4
    },
    border_radius_bottom_left_link_button1:{
        type: 'number',
        default:4
    },
    border_radius_bottom_right_link_button1:{
        type: 'number',
        default:4
    },
    border_size_link_button1:{
        type: 'number',
        default:0
    },
    df_background_color_link_button1:{
        type: 'string',
    },
    df_background_color_hover_link_button1:{
        type: 'string',
    }, 
    df_color_link_button1:{
        type: 'string',
        default: '#fff'
    },
    df_color_hover_link_button1:{
        type: 'string',
        default: '#fff'
    },
    df_border_color_link_button1:{
        type: 'string',
        default: '#fff'
    },
    df_background_color_transparent_link_button1:{
        type: 'string',
        default: 'df-trasparent-color-button1-false'
    },
    df_mask_slider_1:{
        type:'boolean',
        default:false
    },
    background_color_solid_mask_1:{
        type: 'string',
    },
    df_opacity_mask_1: {
        type:'number',
        default:.4
    },
    df_enable_divide_1:{
        type:'bolean',
        default:false
    },
    divide_1:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_1:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_1: {
        type:'number',
        default:60
    },
    df_height_table_divide_1: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_1: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_1: {
        type:'number',
        default:3
    },
    df_enable_divide_bottom_1:{
        type:'bolean',
        default:false
    },
    divide_bottom_1:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_bottom_1:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_bottom_1: {
        type:'number',
        default:60
    },
    df_height_table_divide_bottom_1: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_bottom_1: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_1_bottom: {
        type:'number',
        default:3
    },
    bubiblock_link_slider_1:{
        type:'url'
    },
    bubiblock_link_tab_slider_1:{
        type:'string',
        default:''
    },
    bubiblock_sec_img_1:{
        type:'bolean',
        default:false
    },
    id1: {
        type: 'number'
    },   
 
    // Slider 2
    bubiblock_add_slider_2:{
        type:'boolean',
        default:false
    },
    df_slider_chose_2:{
        type: 'string',
        default: 'df-slider-color-2'
    },
    id2: {
        type: 'number'
    },
    alt2: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-2',
        attribute: 'alt',
        default: ''
    },
    imageUrl_2: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-2',
        attribute: 'src',
    }, 
    df_cover_img2:{
        type: 'string',
        default: 'cover',
    },
    df_focalPoint_img_2: {
        type: 'number',
        default:50
    },
    df_focalPoint_y_img_2: {
        type: 'number',
        default:50
    },
    df_background_color_slider_2:{
        type: 'string',
    }, 
    effectcaption2: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectcaption2:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectcaption2:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectcaption2:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    margin_bottom_caption2: {
        type: 'number',
        default:80
    },
    margin_bottom_table_caption2: {
        type: 'number',
        default:25
    },
    margin_bottom_mobile_caption2: {
        type: 'number',
        default:15
    },
    df_info_table_slider_2:{
        type:'string',
        default:'df-caption-table-true'
    },
    df_info_mobile_slider_2:{
        type:'string',
        default:'df-caption-mobile-false'
    },
    margin_bottom_info2: {
        type: 'number',
        default:40
    },
    margin_bottom_table_info2: {
        type: 'number',
        default:20
    },
    margin_bottom_mobile_info2: {
        type: 'number',
        default:10
    },
    margin_bottom_button2: {
        type: 'number',
        default:5
    },
    margin_bottom_table_button2: {
        type: 'number',
        default:5
    },
    margin_bottom_mobile_button2: {
        type: 'number',
        default:5
    },
    effectinfo2: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectinfo2:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectinfo2:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectinfo2:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    effectbutton2: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectbutton2:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectbutton2:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectbutton2:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    title2: {
        type: 'string',
        source: 'html',
        selector: 'h4.wp-block-bubiblock-slider-slider__title_2'
    },
    fontsizetitle2:{
        type: 'number',
        default:24
    },
    fontsizetitle2table:{
        type: 'number',
        default:22
    },
    fontsizetitle2mobile:{
        type: 'number',
        default:18
    },
    info2: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__info_2'
    },
    fontsizeinfo2:{
        type: 'number',
        default:16
    },
    fontsizeinfo2table:{
        type: 'number',
        default:16
    },
    fontsizeinfo2mobile:{
        type: 'number',
        default:16
    },
    alignment_title2: {
        type: 'string',
        default: 'left'
    },
    alignment_info2: {
        type: 'string',
        default: 'left'
    },
    button2: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__link_2'
    },
    fontsizebutton2:{
        type: 'number',
        default:15
    },
    fontsizebutton2table:{
        type: 'number',
        default:15
    },
    fontsizebutton2mobile:{
        type: 'number',
        default:15
    },
    alignment_button2: {
        type: 'string',
        default: 'right'
    },
    padding_link_button2:{
        type: 'number',
        default:8
    },
    padding_right_link_button2:{
        type: 'number',
        default:20
    },
    border_radius_top_left_link_button2:{
        type: 'number',
        default:4
    },
    border_radius_top_right_link_button2:{
        type: 'number',
        default:4
    },
    border_radius_bottom_left_link_button2:{
        type: 'number',
        default:4
    },
    border_radius_bottom_right_link_button2:{
        type: 'number',
        default:4
    },
    border_size_link_button2:{
        type: 'number',
        default:0
    },
    df_background_color_link_button2:{
        type: 'string',
    },
    df_background_color_hover_link_button2:{
        type: 'string',
    }, 
    df_color_link_button2:{
        type: 'string',
        default: '#fff'
    },
    df_color_hover_link_button2:{
        type: 'string',
        default: '#fff'
    },
    df_border_color_link_button2:{
        type: 'string',
        default: '#fff'
    },
    df_background_color_transparent_link_button2:{
        type: 'string',
        default: 'df-trasparent-color-button2-false'
    },
    df_mask_slider_2:{
        type:'boolean',
        default:false
    },
    background_color_solid_mask_2:{
        type: 'string',
    },
    df_opacity_mask_2: {
        type:'number',
        default:.4
    },
    df_enable_divide_2:{
        type:'bolean',
        default:false
    },
    divide_2:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_2:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_2: {
        type:'number',
        default:60
    },
    df_height_table_divide_2: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_2: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_2: {
        type:'number',
        default:2
    },
    df_enable_divide_bottom_2:{
        type:'bolean',
        default:false
    },
    divide_bottom_2:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_bottom_2:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_bottom_2: {
        type:'number',
        default:60
    },
    df_height_table_divide_bottom_2: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_bottom_2: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_2_bottom: {
        type:'number',
        default:2
    },
    bubiblock_link_slider_2:{
        type:'url'
    },
    bubiblock_link_tab_slider_2:{
        type:'string',
        default:''
    },
    // Slider 3
    bubiblock_add_slider_3:{
        type:'boolean',
        default:false
    },
    df_slider_chose_3:{
        type: 'string',
        default: 'df-slider-color-3'
    },
    id3: {
        type: 'number'
    },
    alt3: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-3',
        attribute: 'alt',
        default: ''
    },
    imageUrl_3: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-3',
        attribute: 'src',
    }, 
    df_cover_img3:{
        type: 'string',
        default: 'cover',
    },
    df_focalPoint_img_3: {
        type: 'number',
        default:50
    },
    df_focalPoint_y_img_3: {
        type: 'number',
        default:50
    },
    df_background_color_slider_3:{
        type: 'string',
    }, 
    effectcaption3: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectcaption3:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectcaption3:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectcaption3:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    margin_bottom_caption3: {
        type: 'number',
        default:80
    },
    margin_bottom_table_caption3: {
        type: 'number',
        default:25
    },
    margin_bottom_mobile_caption3: {
        type: 'number',
        default:15
    },
    df_info_table_slider_3:{
        type:'string',
        default:'df-caption-table-true'
    },
    df_info_mobile_slider_3:{
        type:'string',
        default:'df-caption-mobile-false'
    },
    margin_bottom_info3: {
        type: 'number',
        default:40
    },
    margin_bottom_table_info3: {
        type: 'number',
        default:30
    },
    margin_bottom_mobile_info3: {
        type: 'number',
        default:10
    },
    margin_bottom_button3: {
        type: 'number',
        default:5
    },
    margin_bottom_table_button3: {
        type: 'number',
        default:5
    },
    margin_bottom_mobile_button3: {
        type: 'number',
        default:5
    },
    effectinfo3: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectinfo3:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectinfo3:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectinfo3:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    effectbutton3: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectbutton3:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectbutton3:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectbutton3:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    title3: {
        type: 'string',
        source: 'html',
        selector: 'h4.wp-block-bubiblock-slider-slider__title_3'
    },
    fontsizetitle3:{
        type: 'number',
        default:24
    },
    fontsizetitle3table:{
        type: 'number',
        default:22
    },
    fontsizetitle3mobile:{
        type: 'number',
        default:18
    },
    info3: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__info_3'
    },
    fontsizeinfo3:{
        type: 'number',
        default:16
    },
    fontsizeinfo3table:{
        type: 'number',
        default:16
    },
    fontsizeinfo3mobile:{
        type: 'number',
        default:16
    },
    alignment_title3: {
        type: 'string',
        default: 'left'
    },
    alignment_info3: {
        type: 'string',
        default: 'left'
    },
    button3: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__link_3'
    },
    fontsizebutton3:{
        type: 'number',
        default:15
    },
    fontsizebutton3table:{
        type: 'number',
        default:15
    },
    fontsizebutton3mobile:{
        type: 'number',
        default:15
    },
    alignment_button3: {
        type: 'string',
        default: 'right'
    },
    padding_link_button3:{
        type: 'number',
        default:8
    },
    padding_right_link_button3:{
        type: 'number',
        default:20
    },
    border_radius_top_left_link_button3:{
        type: 'number',
        default:4
    },
    border_radius_top_right_link_button3:{
        type: 'number',
        default:4
    },
    border_radius_bottom_left_link_button3:{
        type: 'number',
        default:4
    },
    border_radius_bottom_right_link_button3:{
        type: 'number',
        default:4
    },
    border_size_link_button3:{
        type: 'number',
        default:0
    },
    df_background_color_link_button3:{
        type: 'string',
    },
    df_background_color_hover_link_button3:{
        type: 'string',
    }, 
    df_color_link_button3:{
        type: 'string',
        default: '#fff'
    },
    df_color_hover_link_button3:{
        type: 'string',
        default: '#fff'
    },
    df_border_color_link_button3:{
        type: 'string',
        default: '#fff'
    },
    df_background_color_transparent_link_button3:{
        type: 'string',
        default: 'df-trasparent-color-button3-false'
    },
    df_mask_slider_3:{
        type:'boolean',
        default:false
    },
    background_color_solid_mask_3:{
        type: 'string',
    },
    df_opacity_mask_3: {
        type:'number',
        default:.4
    },
    df_enable_divide_3:{
        type:'bolean',
        default:false
    },
    divide_3:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_3:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_3: {
        type:'number',
        default:60
    },
    df_height_table_divide_3: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_3: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_3: {
        type:'number',
        default:3
    },
    df_enable_divide_bottom_3:{
        type:'bolean',
        default:false
    },
    divide_bottom_3:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_bottom_3:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_bottom_3: {
        type:'number',
        default:60
    },
    df_height_table_divide_bottom_3: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_bottom_3: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_3_bottom: {
        type:'number',
        default:3
    },
    bubiblock_link_slider_3:{
        type:'url'
    },
    bubiblock_link_tab_slider_3:{
        type:'string',
        default:''
    },
    // Slider 4
    bubiblock_add_slider_4:{
        type:'boolean',
        default:false
    },
    df_slider_chose_4:{
        type: 'string',
        default: 'df-slider-color-4'
    },
    id4: {
        type: 'number'
    },
    alt4: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-4',
        attribute: 'alt',
        default: ''
    },
    imageUrl_4: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-4',
        attribute: 'src',
    }, 
    df_cover_img4:{
        type: 'string',
        default: 'cover',
    },
    df_focalPoint_img_4: {
        type: 'number',
        default:50
    },
    df_focalPoint_y_img_4: {
        type: 'number',
        default:50
    },
    df_background_color_slider_4:{
        type: 'string',
    }, 
    effectcaption4: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectcaption4:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectcaption4:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectcaption4:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    margin_bottom_caption4: {
        type: 'number',
        default:80
    },
    margin_bottom_table_caption4: {
        type: 'number',
        default:25
    },
    margin_bottom_mobile_caption4: {
        type: 'number',
        default:15
    },
    df_info_table_slider_4:{
        type:'string',
        default:'df-caption-table-true'
    },
    df_info_mobile_slider_4:{
        type:'string',
        default:'df-caption-mobile-false'
    },
    margin_bottom_info4: {
        type: 'number',
        default:40
    },
    margin_bottom_table_info4: {
        type: 'number',
        default:30
    },
    margin_bottom_mobile_info4: {
        type: 'number',
        default:10
    },
    margin_bottom_button4: {
        type: 'number',
        default:5
    },
    margin_bottom_table_button4: {
        type: 'number',
        default:5
    },
    margin_bottom_mobile_button4: {
        type: 'number',
        default:5
    },
    effectinfo4: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectinfo4:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectinfo4:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectinfo4:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    effectbutton4: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectbutton4:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectbutton4:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectbutton4:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    title4: {
        type: 'string',
        source: 'html',
        selector: 'h4.wp-block-bubiblock-slider-slider__title_4'
    },
    fontsizetitle4:{
        type: 'number',
        default:24
    },
    fontsizetitle4table:{
        type: 'number',
        default:22
    },
    fontsizetitle4mobile:{
        type: 'number',
        default:18
    },
    info4: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__info_4'
    },
    fontsizeinfo4:{
        type: 'number',
        default:16
    },
    fontsizeinfo4table:{
        type: 'number',
        default:16
    },
    fontsizeinfo4mobile:{
        type: 'number',
        default:16
    },
    alignment_title4: {
        type: 'string',
        default: 'left'
    },
    alignment_info4: {
        type: 'string',
        default: 'left'
    },
    button4: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__link_4'
    },
    fontsizebutton4:{
        type: 'number',
        default:15
    },
    fontsizebutton4table:{
        type: 'number',
        default:15
    },
    fontsizebutton4mobile:{
        type: 'number',
        default:15
    },
    alignment_button4: {
        type: 'string',
        default: 'right'
    },
    padding_link_button4:{
        type: 'number',
        default:8
    },
    padding_right_link_button4:{
        type: 'number',
        default:20
    },
    border_radius_top_left_link_button4:{
        type: 'number',
        default:4
    },
    border_radius_top_right_link_button4:{
        type: 'number',
        default:4
    },
    border_radius_bottom_left_link_button4:{
        type: 'number',
        default:4
    },
    border_radius_bottom_right_link_button4:{
        type: 'number',
        default:4
    },
    border_size_link_button4:{
        type: 'number',
        default:0
    },
    df_background_color_link_button4:{
        type: 'string',
    },
    df_background_color_hover_link_button4:{
        type: 'string',
    }, 
    df_color_link_button4:{
        type: 'string',
        default: '#fff'
    },
    df_color_hover_link_button4:{
        type: 'string',
        default: '#fff'
    },
    df_border_color_link_button4:{
        type: 'string',
        default: '#fff'
    },
    df_background_color_transparent_link_button4:{
        type: 'string',
        default: 'df-trasparent-color-button4-false'
    },
    df_mask_slider_4:{
        type:'boolean',
        default:false
    },
    background_color_solid_mask_4:{
        type: 'string',
    },
    df_opacity_mask_4: {
        type:'number',
        default:.4
    },
    df_enable_divide_4:{
        type:'bolean',
        default:false
    },
    divide_4:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_4:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_4: {
        type:'number',
        default:60
    },
    df_height_table_divide_4: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_4: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_4: {
        type:'number',
        default:3
    },
    df_enable_divide_bottom_4:{
        type:'bolean',
        default:false
    },
    divide_bottom_4:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_bottom_4:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_bottom_4: {
        type:'number',
        default:60
    },
    df_height_table_divide_bottom_4: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_bottom_4: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_4_bottom: {
        type:'number',
        default:3
    },
    bubiblock_link_slider_4:{
        type:'url'
    },
    bubiblock_link_tab_slider_4:{
        type:'string',
        default:''
    },
    // Slider 5
    bubiblock_add_slider_5:{
        type:'boolean',
        default:false
    },
    df_slider_chose_5:{
        type: 'string',
        default: 'df-slider-color-5'
    },
    id5: {
        type: 'number'
    },
    alt5: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-5',
        attribute: 'alt',
        default: ''
    },
    imageUrl_5: {
        type: 'string',
        source: 'attribute',
        selector: 'img.image-slider-5',
        attribute: 'src',
    }, 
    df_cover_img5:{
        type: 'string',
        default: 'cover',
    },
    df_focalPoint_img_5: {
        type: 'number',
        default:50
    },
    df_focalPoint_y_img_5: {
        type: 'number',
        default:50
    },
    df_background_color_slider_5:{
        type: 'string',
    }, 
    effectcaption5: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectcaption5:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectcaption5:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectcaption5:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    margin_bottom_caption5: {
        type: 'number',
        default:80
    },
    margin_bottom_table_caption5: {
        type: 'number',
        default:25
    },
    margin_bottom_mobile_caption5: {
        type: 'number',
        default:15
    },
    df_info_table_slider_5:{
        type:'string',
        default:'df-caption-table-true'
    },
    df_info_mobile_slider_5:{
        type:'string',
        default:'df-caption-mobile-false'
    },
    margin_bottom_info5: {
        type: 'number',
        default:40
    },
    margin_bottom_table_info5: {
        type: 'number',
        default:30
    },
    margin_bottom_mobile_info5: {
        type: 'number',
        default:10
    },
    margin_bottom_button5: {
        type: 'number',
        default:5
    },
    margin_bottom_table_button5: {
        type: 'number',
        default:5
    },
    margin_bottom_mobile_button5: {
        type: 'number',
        default:5
    },
    effectinfo5: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectinfo5:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectinfo5:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectinfo5:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    effectbutton5: {
        type: 'string',
        default: 'df-no-effect'
    },
    df_speed_effectbutton5:{
        type: 'string',
        default: 'animate__slow'
    },
    df_delay_effectbutton5:{
        type: 'string',
        default: 'animate__delay-0s'
    },
    df_repeat_effectbutton5:{
        type: 'string',
        default: 'animate__repeat-1'
    },
    title5: {
        type: 'string',
        source: 'html',
        selector: 'h4.wp-block-bubiblock-slider-slider__title_5'
    },
    fontsizetitle5:{
        type: 'number',
        default:24
    },
    fontsizetitle5table:{
        type: 'number',
        default:22
    },
    fontsizetitle5mobile:{
        type: 'number',
        default:18
    },
    info5: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__info_5'
    },
    fontsizeinfo5:{
        type: 'number',
        default:16
    },
    fontsizeinfo5table:{
        type: 'number',
        default:16
    },
    fontsizeinfo5mobile:{
        type: 'number',
        default:16
    },
    alignment_title5: {
        type: 'string',
        default: 'left'
    },
    alignment_info5: {
        type: 'string',
        default: 'left'
    },
    button5: {
        type: 'string',
        source: 'html',
        selector: 'p.wp-block-bubiblock-slider-slider__link_5'
    },
    fontsizebutton5:{
        type: 'number',
        default:15
    },
    fontsizebutton5table:{
        type: 'number',
        default:15
    },
    fontsizebutton5mobile:{
        type: 'number',
        default:15
    },
    alignment_button5: {
        type: 'string',
        default: 'right'
    },
    padding_link_button5:{
        type: 'number',
        default:8
    },
    padding_right_link_button5:{
        type: 'number',
        default:20
    },
    border_radius_top_left_link_button5:{
        type: 'number',
        default:4
    },
    border_radius_top_right_link_button5:{
        type: 'number',
        default:4
    },
    border_radius_bottom_left_link_button5:{
        type: 'number',
        default:4
    },
    border_radius_bottom_right_link_button5:{
        type: 'number',
        default:4
    },
    border_size_link_button5:{
        type: 'number',
        default:0
    },
    df_background_color_link_button5:{
        type: 'string',
    },
    df_background_color_hover_link_button5:{
        type: 'string',
    }, 
    df_color_link_button5:{
        type: 'string',
        default: '#fff'
    },
    df_color_hover_link_button5:{
        type: 'string',
        default: '#fff'
    },
    df_border_color_link_button5:{
        type: 'string',
        default: '#fff'
    },
    df_background_color_transparent_link_button5:{
        type: 'string',
        default: 'df-trasparent-color-button5-false'
    },
    df_mask_slider_5:{
        type:'boolean',
        default:false
    },
    background_color_solid_mask_5:{
        type: 'string',
    },
    df_opacity_mask_5: {
        type:'number',
        default:.4
    },
    df_enable_divide_5:{
        type:'bolean',
        default:false
    },
    divide_5:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_5:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_5: {
        type:'number',
        default:60
    },
    df_height_table_divide_5: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_5: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_5: {
        type:'number',
        default:3
    },
    df_enable_divide_bottom_5:{
        type:'bolean',
        default:false
    },
    divide_bottom_5:{
        type: 'string',
        default: 'svg-1'
    },
    df_color_divide_bottom_5:{
        type: 'string',
        default: '#fff',
    },
    df_height_divide_bottom_5: {
        type:'number',
        default:60
    },
    df_height_table_divide_bottom_5: {
        type:'number',
        default:60
    },
    df_height_mobile_divide_bottom_5: {
        type:'number',
        default:60
    },
    bubiblock_dalay_divide_5_bottom: {
        type:'number',
        default:3
    },
    bubiblock_link_slider_5:{
        type:'url'
    },
    bubiblock_link_tab_slider_5:{
        type:'string',
        default:''
    },
}

registerBlockType('bubiblock-slider/slider', {
    title:__('Bubiblock Slider','bubiblock-slider'),
    description:__('Slider Block for Gutenberg, highlight your works in a few clicks!','bubiblock-slider'),
    category:'media',
    icon: {foreground: '#8321D2',src:'embed-photo bubiblock-icon-description' },
    supports: {
        reusable: false,
        html: false,
        align: true,
        align: [ 'center','full' ]
    },
    keywords: [ __('slider','bubiblock-slider'), __('carousel','bubiblock-slider')],
    attributes,

    save: ( {attributes} ) => {

        const {
            bubiblock_padding_caption,
            bubiblock_padding_table_caption,
            bubiblock_padding_mobile_caption,
            bubiblock_display_button_table_caption,
            bubiblock_display_button_mobile_caption,
            bubiblock_speed_flip_slider,
            bubiblcok_fontfamily,
            bubiblock_typography_custom,
            bubiblcok_fontfamily_weight,
            bubiblock_line_height_title,
            bubiblcok_fontfamily_descritpion,
            bubiblcok_fontfamily_weight_description,
            bubiblock_line_height_info,
            bubiblcok_fontfamily_button,
            bubiblcok_fontfamily_weight_button,
            height_slider,
            df_height_slider_auto,
            height_slider_table,
            height_slider_mobile,
            bubiblock_full_slider,
            bubiblock_padding_slider,
            bubiblock_padding_table_slider,
            bubiblock_padding_b_table_slider,
            bubiblock_padding_mobile_slider,
            bubiblock_padding_b_mobile_slider,
            bubiblock_padding_b_slider,
            bubiblock_radius_slider,
            bubiblock_background_color_slider,
            df_interval_slider,
            bubiblock_id_slider,
            df_pause_slider,
            df_effect_slider,
            bubiblock_show_slider_desktop,
            bubiblock_show_slider_table,
            bubiblock_show_slider_mobile,
            bubiblock_carousle_touch,
            bubi_block_content_slider,
            bubiblock_padding_block_slider,
            bubiblock_padding_b_block_slider,
            bubiblock_padding_block_slider_table,
            bubiblock_padding_b_block_slider_table,
            bubiblock_padding_block_slider_mobile,
            bubiblock_padding_b_block_slider_mobile,
            bubiblock_background_color_block_slider,
            bubiopacityblock_slider,
            df_arrow_slider,
            df_arrow_slider_table,
            df_arrow_slider_mobile,
            df_color_arrow,
            bubiopacityarrow,
            bubiopacityhoverarrow,
            df_padding_arrow,
            df_radius_arrow,
            df_size_arrow,
            df_size_arrow_table,
            df_size_arrow_mobile,
            bubi_marginarrow,
            df_arrow_slider_type,
            bubi_arrow_position,
            df_dot_slider,
            df_dot_slider_table,
            df_dot_slider_mobile,
            df_dot_slider_type,
            df_width_dot,
            df_height_dot,
            bubiblock_height_dot_active_enable,
            bubiblock_height_dot_active,
            bubiblock_progress_dot_enable,
            df_color_progress_dot,
            df_spacing_dot,
            df_bottom_dot,
            df_color_dot,
            // Slider 1
            df_slider_chose_1,
            effectcaption1,
            df_speed_effectcaption1,
            df_delay_effectcaption1,
            df_repeat_effectcaption1,
            df_mask_slider_1,
            background_color_solid_mask_1,
            df_opacity_mask_1,
            margin_bottom_caption1,
            margin_bottom_table_caption1,
            margin_bottom_mobile_caption1,
            margin_bottom_info1,
            margin_bottom_table_info1,
            margin_bottom_mobile_info1,
            margin_bottom_button1,
            margin_bottom_table_button1,
            margin_bottom_mobile_button1,
            effectinfo1,
            df_speed_effectinfo1,
            df_delay_effectinfo1,
            df_repeat_effectinfo1,
            effectbutton1,
            df_speed_effectbutton1,
            df_delay_effectbutton1,
            df_repeat_effectbutton1,
            title1,
            fontsizetitle1,
            fontsizetitle1table,
            fontsizetitle1mobile,
            info1,
            fontsizeinfo1,
            fontsizeinfo1table,
            fontsizeinfo1mobile,
            alignment_title1,
            alignment_info1,
            button1,
            fontsizebutton1,
            fontsizebutton1table,
            fontsizebutton1mobile,
            alignment_button1,
            padding_link_button1,
            padding_right_link_button1,
            border_radius_top_left_link_button1,
            border_radius_top_right_link_button1,
            border_radius_bottom_left_link_button1, 
            border_radius_bottom_right_link_button1,
            border_size_link_button1,
            df_background_color_link_button1,
            df_background_color_hover_link_button1,
            df_color_link_button1,
            df_color_hover_link_button1,
            df_border_color_link_button1,
            df_background_color_transparent_link_button1,
            url, 
            alt, 
            id, 
            df_cover_img1,
            df_focalPoint_img_1,
            df_focalPoint_y_img_1,
            df_background_color_slider_1,
            df_background_gradient_slider_1,
            df_enable_divide_1,
            divide_1,
            df_color_divide_1,
            df_height_divide_1,
            bubiblock_dalay_divide_1,
            df_height_table_divide_1,
            df_height_mobile_divide_1,
            df_enable_divide_bottom_1,
            divide_bottom_1,
            df_color_divide_bottom_1,
            df_height_divide_bottom_1,
            df_height_table_divide_bottom_1,
            df_height_mobile_divide_bottom_1,
            bubiblock_dalay_divide_1_bottom,
            bubiblock_link_slider_1,
            bubiblock_link_tab_slider_1,
            id1,
            // Slider 2
            df_slider_chose_2,
            df_mask_slider_2,
            background_color_solid_mask_2,
            df_opacity_mask_2,
            effectcaption2,
            df_speed_effectcaption2,
            df_delay_effectcaption2,
            df_repeat_effectcaption2,
            margin_bottom_caption2,
            margin_bottom_table_caption2,
            margin_bottom_mobile_caption2,
            margin_bottom_info2,
            margin_bottom_table_info2,
            margin_bottom_mobile_info2,
            effectinfo2,
            df_speed_effectinfo2,
            df_delay_effectinfo2,
            df_repeat_effectinfo2,
            title2,
            fontsizetitle2,
            fontsizetitle2table,
            fontsizetitle2mobile,
            info2,
            fontsizeinfo2,
            fontsizeinfo2table,
            fontsizeinfo2mobile,
            margin_bottom_button2,
            margin_bottom_table_button2,
            margin_bottom_mobile_button2,
            effectbutton2,
            df_speed_effectbutton2,
            df_delay_effectbutton2,
            df_repeat_effectbutton2,
            alignment_title2,
            alignment_info2,
            button2,
            fontsizebutton2,
            fontsizebutton2table,
            fontsizebutton2mobile,
            alignment_button2,
            padding_link_button2,
            padding_right_link_button2,
            border_radius_top_left_link_button2,
            border_radius_top_right_link_button2,
            border_radius_bottom_left_link_button2, 
            border_radius_bottom_right_link_button2,
            border_size_link_button2,
            df_background_color_link_button2,
            df_background_color_hover_link_button2,
            df_color_link_button2,
            df_color_hover_link_button2,
            df_border_color_link_button2,
            df_background_color_transparent_link_button2,
            alt2, 
            id2,
            imageUrl_2,
            df_cover_img2,
            df_focalPoint_img_2,
            df_focalPoint_y_img_2,
            df_background_color_slider_2,
            df_enable_divide_2,
            divide_2,
            df_color_divide_2,
            df_height_divide_2,
            df_height_table_divide_2,
            df_height_mobile_divide_2,
            bubiblock_dalay_divide_2,
            df_enable_divide_bottom_2,
            divide_bottom_2,
            df_color_divide_bottom_2,
            df_height_divide_bottom_2,
            df_height_table_divide_bottom_2,
            df_height_mobile_divide_bottom_2,
            bubiblock_dalay_divide_2_bottom,
            bubiblock_link_slider_2,
            bubiblock_link_tab_slider_2,
            // Slider 3
            bubiblock_add_slider_3,
            df_slider_chose_3,
            df_mask_slider_3,
            background_color_solid_mask_3,
            df_opacity_mask_3,
            effectcaption3,
            df_speed_effectcaption3,
            df_delay_effectcaption3,
            df_repeat_effectcaption3,
            margin_bottom_caption3,
            margin_bottom_table_caption3,
            margin_bottom_mobile_caption3,
            margin_bottom_info3,
            margin_bottom_table_info3,
            margin_bottom_mobile_info3,
            effectinfo3,
            df_speed_effectinfo3,
            df_delay_effectinfo3,
            df_repeat_effectinfo3,
            title3,
            fontsizetitle3,
            fontsizetitle3table,
            fontsizetitle3mobile,
            info3,
            fontsizeinfo3,
            fontsizeinfo3table,
            fontsizeinfo3mobile,
            margin_bottom_button3,
            margin_bottom_table_button3,
            margin_bottom_mobile_button3,
            effectbutton3,
            df_speed_effectbutton3,
            df_delay_effectbutton3,
            df_repeat_effectbutton3,
            alignment_title3,
            alignment_info3,
            button3,
            fontsizebutton3,
            fontsizebutton3table,
            fontsizebutton3mobile,
            alignment_button3,
            padding_link_button3,
            padding_right_link_button3,
            border_radius_top_left_link_button3,
            border_radius_top_right_link_button3,
            border_radius_bottom_left_link_button3, 
            border_radius_bottom_right_link_button3,
            border_size_link_button3,
            df_background_color_link_button3,
            df_background_color_hover_link_button3,
            df_color_link_button3,
            df_color_hover_link_button3,
            df_border_color_link_button3,
            df_background_color_transparent_link_button3,
            alt3, 
            id3,
            imageUrl_3,
            df_cover_img3,
            df_focalPoint_img_3,
            df_focalPoint_y_img_3,
            df_background_color_slider_3,
            df_enable_divide_3,
            divide_3,
            df_color_divide_3,
            df_height_divide_3,
            df_height_table_divide_3,
            df_height_mobile_divide_3,
            bubiblock_dalay_divide_3,
            df_enable_divide_bottom_3,
            divide_bottom_3,
            df_color_divide_bottom_3,
            df_height_divide_bottom_3,
            df_height_table_divide_bottom_3,
            df_height_mobile_divide_bottom_3,
            bubiblock_dalay_divide_3_bottom,
            bubiblock_link_slider_3,
            bubiblock_link_tab_slider_3,
            // Slider 4
            bubiblock_add_slider_4,
            df_slider_chose_4,
            df_mask_slider_4,
            background_color_solid_mask_4,
            df_opacity_mask_4,
            effectcaption4,
            df_speed_effectcaption4,
            df_delay_effectcaption4,
            df_repeat_effectcaption4,
            margin_bottom_caption4,
            margin_bottom_table_caption4,
            margin_bottom_mobile_caption4,
            margin_bottom_info4,
            margin_bottom_table_info4,
            margin_bottom_mobile_info4,
            effectinfo4,
            df_speed_effectinfo4,
            df_delay_effectinfo4,
            df_repeat_effectinfo4,
            title4,
            fontsizetitle4,
            fontsizetitle4table,
            fontsizetitle4mobile,
            info4,
            fontsizeinfo4,
            fontsizeinfo4table,
            fontsizeinfo4mobile,
            margin_bottom_button4,
            margin_bottom_table_button4,
            margin_bottom_mobile_button4,
            effectbutton4,
            df_speed_effectbutton4,
            df_delay_effectbutton4,
            df_repeat_effectbutton4,
            alignment_title4,
            alignment_info4,
            button4,
            fontsizebutton4,
            fontsizebutton4table,
            fontsizebutton4mobile,
            alignment_button4,
            padding_link_button4,
            padding_right_link_button4,
            border_radius_top_left_link_button4,
            border_radius_top_right_link_button4,
            border_radius_bottom_left_link_button4, 
            border_radius_bottom_right_link_button4,
            border_size_link_button4,
            df_background_color_link_button4,
            df_background_color_hover_link_button4,
            df_color_link_button4,
            df_color_hover_link_button4,
            df_border_color_link_button4,
            df_background_color_transparent_link_button4,
            alt4, 
            id4,
            imageUrl_4,
            df_cover_img4,
            df_focalPoint_img_4,
            df_focalPoint_y_img_4,
            df_background_color_slider_4,
            df_enable_divide_4,
            divide_4,
            df_color_divide_4,
            df_height_divide_4,
            df_height_table_divide_4,
            df_height_mobile_divide_4,
            bubiblock_dalay_divide_4,
            df_enable_divide_bottom_4,
            divide_bottom_4,
            df_color_divide_bottom_4,
            df_height_divide_bottom_4,
            df_height_table_divide_bottom_4,
            df_height_mobile_divide_bottom_4,
            bubiblock_dalay_divide_4_bottom,
            bubiblock_link_slider_4,
            bubiblock_link_tab_slider_4,
            // Slider 5
            bubiblock_add_slider_5,
            df_slider_chose_5,
            df_mask_slider_5,
            background_color_solid_mask_5,
            df_opacity_mask_5,
            effectcaption5,
            df_speed_effectcaption5,
            df_delay_effectcaption5,
            df_repeat_effectcaption5,
            margin_bottom_caption5,
            margin_bottom_table_caption5,
            margin_bottom_mobile_caption5,
            margin_bottom_info5,
            margin_bottom_table_info5,
            margin_bottom_mobile_info5,
            effectinfo5,
            df_speed_effectinfo5,
            df_delay_effectinfo5,
            df_repeat_effectinfo5,
            title5,
            fontsizetitle5,
            fontsizetitle5table,
            fontsizetitle5mobile,
            info5,
            fontsizeinfo5,
            fontsizeinfo5table,
            fontsizeinfo5mobile,
            margin_bottom_button5,
            margin_bottom_table_button5,
            margin_bottom_mobile_button5,
            effectbutton5,
            df_speed_effectbutton5,
            df_delay_effectbutton5,
            df_repeat_effectbutton5,
            alignment_title5,
            alignment_info5,
            button5,
            fontsizebutton5,
            fontsizebutton5table,
            fontsizebutton5mobile,
            alignment_button5,
            padding_link_button5,
            padding_right_link_button5,
            border_radius_top_left_link_button5,
            border_radius_top_right_link_button5,
            border_radius_bottom_left_link_button5, 
            border_radius_bottom_right_link_button5,
            border_size_link_button5,
            df_background_color_link_button5,
            df_background_color_hover_link_button5,
            df_color_link_button5,
            df_color_hover_link_button5,
            df_border_color_link_button5,
            df_background_color_transparent_link_button5,
            alt5, 
            id5,
            imageUrl_5,
            df_cover_img5,
            df_focalPoint_img_5,
            df_focalPoint_y_img_5,
            df_background_color_slider_5,
            df_enable_divide_5,
            divide_5,
            df_color_divide_5,
            df_height_divide_5,
            df_height_table_divide_5,
            df_height_mobile_divide_5,
            bubiblock_dalay_divide_5,
            df_enable_divide_bottom_5,
            divide_bottom_5,
            df_color_divide_bottom_5,
            df_height_divide_bottom_5,
            df_height_table_divide_bottom_5,
            df_height_mobile_divide_bottom_5,
            bubiblock_dalay_divide_5_bottom,
            bubiblock_link_slider_5,
            bubiblock_link_tab_slider_5,
    
        } = attributes;

        return (
           
            <div id={'carouselDFControlslider'+bubiblock_id_slider} className={'df_height_carousel_block bubiblock_on_slider_desktop'+bubiblock_show_slider_desktop+' bubiblock_on_slider_table'+bubiblock_show_slider_table+' bubiblock_on_slider_mobile'+bubiblock_show_slider_mobile+' carousel slide caption-animate touch'+bubiblock_carousle_touch+' '+df_effect_slider+' '+df_pause_slider} data-ride="carousel" data-interval={df_interval_slider} style={{background:bubiblock_background_color_slider}}>
                    <ol className={df_dot_slider+' '+df_dot_slider_table+' '+df_dot_slider_mobile+' carousel-indicators prog'+bubiblock_progress_dot_enable+' diff'+bubiblock_height_dot_active_enable} style={{bottom:df_bottom_dot}}> 
                        <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="0" className={'active '+df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',marginLeft:df_spacing_dot+'px',marginRight:df_spacing_dot+'px',backgroundColor:df_color_dot}}></li>
                        <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="1" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',marginLeft:df_spacing_dot+'px',marginRight:df_spacing_dot+'px',backgroundColor:df_color_dot}}></li> 
                        {bubiblock_add_slider_3 &&
                            <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="2" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',marginLeft:df_spacing_dot+'px',marginRight:df_spacing_dot+'px',backgroundColor:df_color_dot}}></li>
                        }
                        {bubiblock_add_slider_4 &&
                            <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="3" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',marginLeft:df_spacing_dot+'px',marginRight:df_spacing_dot+'px',backgroundColor:df_color_dot}}></li>
                        }
                         {bubiblock_add_slider_5 &&
                            <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="4" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',marginLeft:df_spacing_dot+'px',marginRight:df_spacing_dot+'px',backgroundColor:df_color_dot}}></li>
                        }
                    </ol>
                    <div className={'carousel-inner'}> 
                    {(bubi_block_content_slider == 'bubiblock-block-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                        <div className={'bubiblock-block'} style={{backgroundColor:bubiblock_background_color_block_slider,opacity:bubiopacityblock_slider}}>
                            <InnerBlocks.Content />
                        </div>
                    }
                        <div className={'carousel-item '+df_effect_slider+' '+bubiblock_id_slider+' active '}> 
                            { df_enable_divide_1 &&
                                <div className={'df-divide-1'} style={{color:df_color_divide_1}}>
                                    {(divide_1=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_1=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_1=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_1=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_1 &&
                                <div className={'df-divide-bottom-1'} style={{color:df_color_divide_bottom_1}}>
                                    {(divide_bottom_1=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_1=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_1=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_1=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_1=='df-slider-image-1' ) && 
                                <>
                                {url &&
                                <>
                                <a href={bubiblock_link_slider_1} target={bubiblock_link_tab_slider_1} rel="noopener">
                                    <img src={url} alt={alt} className={'img-cap'} style={{objectFit:df_cover_img1,objectPosition:df_focalPoint_img_1+'% '+df_focalPoint_y_img_1+'%'}}/> 
                                {df_mask_slider_1 &&
                                    <div className={'mask'} style={{backgroundColor:background_color_solid_mask_1,opacity:df_opacity_mask_1}}></div>
                                }
                                </a>
                                </>
                                } 
                                </>
                            }
                            {(df_slider_chose_1=='df-slider-color-1' ) && 
                                <>
                                {df_background_gradient_slider_1 + df_background_color_slider_1 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{background:df_background_gradient_slider_1,backgroundColor: df_background_color_slider_1}}></div> 
                                    : 
                                    <div className={'df-color-default-background-slider bubiblock-color-slider-item'}></div>  
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-1'} >
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText.Content
                                                className={ 'wp-block-bubiblock-slider-slider__title '+df_repeat_effectcaption1+' '+df_delay_effectcaption1+' '+df_speed_effectcaption1+' '+effectcaption1 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title1,fontSize:fontsizetitle1+'px',bottom:margin_bottom_caption1+'px'}}
                                                value= { title1 }
                                            />
                                            <RichText.Content
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info '+df_repeat_effectinfo1+' '+df_delay_effectinfo1+' '+df_speed_effectinfo1+' '+effectinfo1}
                                                tagName= "p"
                                                value= { info1 }
                                                style={{textAlign:alignment_info1,fontSize:fontsizeinfo1+'px',bottom:margin_bottom_info1+'px'}}
                                            />
                                            {button1 &&
                                                <div className={'link-button-1 '+df_repeat_effectbutton1+' '+df_delay_effectbutton1+' '+df_speed_effectbutton1+' '+effectbutton1} style={{textAlign:alignment_button1,bottom:margin_bottom_button1+'px'}}>
                                                    <button className={'button-slider '+df_background_color_transparent_link_button1} style={
                                                        {
                                                            paddingTop:padding_link_button1+'px',
                                                            paddingBottom:padding_link_button1+'px',
                                                            paddingLeft:padding_right_link_button1+'px',
                                                            paddingRight:padding_right_link_button1+'px',
                                                            borderTopLeftRadius: border_radius_top_left_link_button1+'px', 
                                                            borderTopRightRadius: border_radius_top_right_link_button1+'px',
                                                            borderBottomLeftRadius: border_radius_bottom_left_link_button1+'px', 
                                                            borderBottomRightRadius: border_radius_bottom_right_link_button1+'px',
                                                            border: border_size_link_button1+'px solid'+df_border_color_link_button1,
                                                            backgroundColor:df_background_color_link_button1,
                                                            background:df_background_color_link_button1,
                                                        }
                                                    }>
                                                        <RichText.Content
                                                            className={ 'wp-block-bubiblock-slider-slider__link' }
                                                            tagName= "p"
                                                            value= { button1 }
                                                            style={{fontSize:fontsizebutton1+'px',color:df_color_link_button1}}
                                                        />
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>  
                            }
                        </div>   
                    
                        <div className={'carousel-item '+df_effect_slider+' '+bubiblock_id_slider}> 
                            { df_enable_divide_2 &&
                                <div className={'df-divide-2'} style={{color:df_color_divide_2}}>
                                    {(divide_2=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_2=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_2=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_2=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_2 &&
                                <div className={'df-divide-bottom-2'} style={{color:df_color_divide_bottom_2}}>
                                    {(divide_bottom_2=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_2=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_2=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_2=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_2=='df-slider-image-2' ) &&
                                <>
                                {imageUrl_2 &&
                                    <> 
                                    <a href={bubiblock_link_slider_2} target={bubiblock_link_tab_slider_2} rel="noopener">
                                        <img src={imageUrl_2} alt={alt2} className={'img-cap image-slider-2'} style={{objectFit:df_cover_img2,objectPosition:df_focalPoint_img_2+'% '+df_focalPoint_y_img_2+'%'}} />
                                    {df_mask_slider_2 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_2,opacity:df_opacity_mask_2}}></div>
                                    }
                                    </a>
                                    </>                 
                                }
                                </>
                            }  
                            {(df_slider_chose_2=='df-slider-color-2') && 
                                <>
                                {df_background_color_slider_2 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_2}}></div> 
                                    : 
                                    <div className={'df-color-default-background-slider-2 bubiblock-color-slider-item'}></div>  
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-2'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText.Content
                                                className={ 'wp-block-bubiblock-slider-slider__title_2 '+df_repeat_effectcaption2+' '+df_delay_effectcaption2+' '+df_speed_effectcaption2+' '+effectcaption2 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title2,fontSize:fontsizetitle2+'px',bottom:margin_bottom_caption2+'px'}}
                                                value= { title2 }
                                            />
                                            <RichText.Content
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_2 '+df_repeat_effectinfo2+' '+df_delay_effectinfo2+' '+df_speed_effectinfo2+' '+effectinfo2}
                                                tagName= "p"
                                                value= { info2 }
                                                style={{textAlign:alignment_info2,fontSize:fontsizeinfo2+'px',bottom:margin_bottom_info2+'px'}}
                                            />
                                            {button2 &&
                                                <div className={'link-button-2 '+df_repeat_effectbutton2+' '+df_delay_effectbutton2+' '+df_speed_effectbutton2+' '+effectbutton2} style={{textAlign:alignment_button2,bottom:margin_bottom_button2+'px'}}>
                                                    <button className={'button-slider2 '+df_background_color_transparent_link_button2} style={
                                                        {
                                                            paddingTop:padding_link_button2+'px',
                                                            paddingBottom:padding_link_button2+'px',
                                                            paddingLeft:padding_right_link_button2+'px',
                                                            paddingRight:padding_right_link_button2+'px',
                                                            borderTopLeftRadius: border_radius_top_left_link_button2+'px', 
                                                            borderTopRightRadius: border_radius_top_right_link_button2+'px',
                                                            borderBottomLeftRadius: border_radius_bottom_left_link_button2+'px', 
                                                            borderBottomRightRadius: border_radius_bottom_right_link_button2+'px',
                                                            border: border_size_link_button2+'px solid'+df_border_color_link_button2,
                                                            backgroundColor:df_background_color_link_button2,
                                                            background:df_background_color_link_button2,
                                                        }
                                                    }
                                                    >
                                                        <RichText.Content
                                                            className={ 'wp-block-bubiblock-slider-slider__link_2' }
                                                            tagName= "p"
                                                            value= { button2 }
                                                            style={{fontSize:fontsizebutton2+'px',color:df_color_link_button2}}
                                                        />
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div> 

                        {bubiblock_add_slider_3 && // Slider 3
                        <div className={'carousel-item '+df_effect_slider}> 
                            { df_enable_divide_3 &&
                                <div className={'df-divide-3'} style={{color:df_color_divide_3}}>
                                    {(divide_3=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_3=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_3=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_3=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_3 &&
                                <div className={'df-divide-bottom-3'} style={{color:df_color_divide_bottom_3}}>
                                    {(divide_bottom_3=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_3=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_3=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_3=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_3=='df-slider-image-3' ) &&
                                <>
                                {imageUrl_3 &&
                                    <> 
                                    <a href={bubiblock_link_slider_3} target={bubiblock_link_tab_slider_3} rel="noopener">
                                        <img src={imageUrl_3} alt={alt3} className={'img-cap image-slider-3'} style={{objectFit:df_cover_img3,objectPosition:df_focalPoint_img_3+'% '+df_focalPoint_y_img_3+'%'}} />
                                    {df_mask_slider_3 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_3,opacity:df_opacity_mask_3}}></div>
                                    }
                                    </a>
                                    </>                 
                                }
                                </>
                            }  
                            {(df_slider_chose_3=='df-slider-color-3') && 
                                <>
                                {df_background_color_slider_3 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_3}}></div> 
                                    : 
                                    <div className={'df-color-default-background-slider bubiblock-color-slider-item'}></div>  
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-3'} >
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText.Content
                                                className={ 'wp-block-bubiblock-slider-slider__title_3 '+df_repeat_effectcaption3+' '+df_delay_effectcaption3+' '+df_speed_effectcaption3+' '+effectcaption3 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title3,fontSize:fontsizetitle3+'px',bottom:margin_bottom_caption3+'px'}}
                                                value= { title3 }
                                            />
                                            <RichText.Content
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_3 '+df_repeat_effectinfo3+' '+df_delay_effectinfo3+' '+df_speed_effectinfo3+' '+effectinfo3}
                                                tagName= "p"
                                                value= { info3 }
                                                style={{textAlign:alignment_info3,fontSize:fontsizeinfo3+'px',bottom:margin_bottom_info3+'px'}}
                                            />
                                            {button3 &&
                                                <div className={'link-button-3 '+df_repeat_effectbutton3+' '+df_delay_effectbutton3+' '+df_speed_effectbutton3+' '+effectbutton3} style={{textAlign:alignment_button3,bottom:margin_bottom_button3+'px'}}>
                                                    <button className={'button-slider3 '+df_background_color_transparent_link_button3} style={
                                                        {
                                                            paddingTop:padding_link_button3+'px',
                                                            paddingBottom:padding_link_button3+'px',
                                                            paddingLeft:padding_right_link_button3+'px',
                                                            paddingRight:padding_right_link_button3+'px',
                                                            borderTopLeftRadius: border_radius_top_left_link_button3+'px', 
                                                            borderTopRightRadius: border_radius_top_right_link_button3+'px',
                                                            borderBottomLeftRadius: border_radius_bottom_left_link_button3+'px', 
                                                            borderBottomRightRadius: border_radius_bottom_right_link_button3+'px',
                                                            border: border_size_link_button3+'px solid'+df_border_color_link_button3,
                                                            backgroundColor:df_background_color_link_button3,
                                                            background:df_background_color_link_button3,
                                                        }
                                                    }
                                                    >
                                                        <RichText.Content
                                                            className={ 'wp-block-bubiblock-slider-slider__link_3' }
                                                            tagName= "p"
                                                            value= { button3 }
                                                            style={{fontSize:fontsizebutton3+'px',color:df_color_link_button3}}
                                                        />
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div> 
                        }

                        {bubiblock_add_slider_4 && // Slider 4
                        <div className={'carousel-item '+df_effect_slider}> 
                            { df_enable_divide_4 &&
                                <div className={'df-divide-4'} style={{color:df_color_divide_4}}>
                                    {(divide_4=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_4=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_4=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_4=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_4 &&
                                <div className={'df-divide-bottom-4'} style={{color:df_color_divide_bottom_4}}>
                                    {(divide_bottom_4=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_4=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_4=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_4=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_4=='df-slider-image-4' ) &&
                                <>
                                {imageUrl_4 &&
                                    <> 
                                    <a href={bubiblock_link_slider_4} target={bubiblock_link_tab_slider_4} rel="noopener">
                                        <img src={imageUrl_4} alt={alt4} className={'img-cap image-slider-4'} style={{objectFit:df_cover_img4,objectPosition:df_focalPoint_img_4+'% '+df_focalPoint_y_img_4+'%'}} />
                                    {df_mask_slider_4 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_4,opacity:df_opacity_mask_4}}></div>
                                    }
                                    </a>
                                    </>                 
                                }
                                </>
                            }  
                            {(df_slider_chose_4=='df-slider-color-4') && 
                                <>
                                {df_background_color_slider_4 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_4}}></div> 
                                    : 
                                    <div className={'df-color-default-background-slider-2 bubiblock-color-slider-item'}></div>  
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-4'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText.Content
                                                className={ 'wp-block-bubiblock-slider-slider__title_4 '+df_repeat_effectcaption4+' '+df_delay_effectcaption4+' '+df_speed_effectcaption4+' '+effectcaption4 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title4,fontSize:fontsizetitle4+'px',bottom:margin_bottom_caption4+'px'}}
                                                value= { title4 }
                                            />
                                            <RichText.Content
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_4 '+df_repeat_effectinfo4+' '+df_delay_effectinfo4+' '+df_speed_effectinfo4+' '+effectinfo4}
                                                tagName= "p"
                                                value= { info4 }
                                                style={{textAlign:alignment_info4,fontSize:fontsizeinfo4+'px',bottom:margin_bottom_info4+'px'}}
                                            />
                                            {button4 &&
                                                <div className={'link-button-4 '+df_repeat_effectbutton4+' '+df_delay_effectbutton4+' '+df_speed_effectbutton4+' '+effectbutton4} style={{textAlign:alignment_button4,bottom:margin_bottom_button4+'px'}}>
                                                    <button className={'button-slider4 '+df_background_color_transparent_link_button4} style={
                                                        {
                                                            paddingTop:padding_link_button4+'px',
                                                            paddingBottom:padding_link_button4+'px',
                                                            paddingLeft:padding_right_link_button4+'px',
                                                            paddingRight:padding_right_link_button4+'px',
                                                            borderTopLeftRadius: border_radius_top_left_link_button4+'px', 
                                                            borderTopRightRadius: border_radius_top_right_link_button4+'px',
                                                            borderBottomLeftRadius: border_radius_bottom_left_link_button4+'px', 
                                                            borderBottomRightRadius: border_radius_bottom_right_link_button4+'px',
                                                            border: border_size_link_button4+'px solid'+df_border_color_link_button4,
                                                            backgroundColor:df_background_color_link_button4,
                                                            background:df_background_color_link_button4,
                                                        }
                                                    }
                                                    >
                                                        <RichText.Content
                                                            className={ 'wp-block-bubiblock-slider-slider__link_4' }
                                                            tagName= "p"
                                                            value= { button4 }
                                                            style={{fontSize:fontsizebutton4+'px',color:df_color_link_button4}}
                                                        />
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div> 
                        }
                        {bubiblock_add_slider_5 && // Slider 5
                        <div className={'carousel-item '+df_effect_slider}> 
                            { df_enable_divide_5 &&
                                <div className={'df-divide-5'} style={{color:df_color_divide_5}}>
                                    {(divide_5=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_5=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_5=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_5=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_5 &&
                                <div className={'df-divide-bottom-5'} style={{color:df_color_divide_bottom_5}}>
                                    {(divide_bottom_5=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_5=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_5=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_5=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_5=='df-slider-image-5' ) &&
                                <>
                                {imageUrl_5 &&
                                    <> 
                                    <a href={bubiblock_link_slider_5} target={bubiblock_link_tab_slider_5} rel="noopener">
                                        <img src={imageUrl_5} alt={alt5} className={'img-cap image-slider-5'} style={{objectFit:df_cover_img5,objectPosition:df_focalPoint_img_5+'% '+df_focalPoint_y_img_5+'%'}} />
                                    {df_mask_slider_5 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_5,opacity:df_opacity_mask_5}}></div>
                                    }
                                    </a>
                                    </>                 
                                }
                                </>
                            }  
                            {(df_slider_chose_5=='df-slider-color-5') && 
                                <>
                                {df_background_color_slider_5 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_5}}></div> 
                                    : 
                                    <div className={'df-color-default-background-slider bubiblock-color-slider-item'}></div>  
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-5'} >
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText.Content
                                                className={ 'wp-block-bubiblock-slider-slider__title_5 '+df_repeat_effectcaption5+' '+df_delay_effectcaption5+' '+df_speed_effectcaption5+' '+effectcaption5 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title5,fontSize:fontsizetitle5+'px',bottom:margin_bottom_caption5+'px'}}
                                                value= { title5 }
                                            />
                                            <RichText.Content
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_5 '+df_repeat_effectinfo5+' '+df_delay_effectinfo5+' '+df_speed_effectinfo5+' '+effectinfo5}
                                                tagName= "p"
                                                value= { info5 }
                                                style={{textAlign:alignment_info5,fontSize:fontsizeinfo5+'px',bottom:margin_bottom_info5+'px'}}
                                            />
                                            {button5 &&
                                                <div className={'link-button-5 '+df_repeat_effectbutton5+' '+df_delay_effectbutton5+' '+df_speed_effectbutton5+' '+effectbutton5} style={{textAlign:alignment_button5,bottom:margin_bottom_button5+'px'}}>
                                                    <button className={'button-slider5 '+df_background_color_transparent_link_button5} style={
                                                        {
                                                            paddingTop:padding_link_button5+'px',
                                                            paddingBottom:padding_link_button5+'px',
                                                            paddingLeft:padding_right_link_button5+'px',
                                                            paddingRight:padding_right_link_button5+'px',
                                                            borderTopLeftRadius: border_radius_top_left_link_button5+'px', 
                                                            borderTopRightRadius: border_radius_top_right_link_button5+'px',
                                                            borderBottomLeftRadius: border_radius_bottom_left_link_button5+'px', 
                                                            borderBottomRightRadius: border_radius_bottom_right_link_button5+'px',
                                                            border: border_size_link_button5+'px solid'+df_border_color_link_button5,
                                                            backgroundColor:df_background_color_link_button5,
                                                            background:df_background_color_link_button5,
                                                        }
                                                    }
                                                    >
                                                        <RichText.Content
                                                            className={ 'wp-block-bubiblock-slider-slider__link_5' }
                                                            tagName= "p"
                                                            value= { button5 }
                                                            style={{fontSize:fontsizebutton5+'px',color:df_color_link_button5}}
                                                        />
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div> 
                        }
                    </div> 
                    <a className={'carousel-control-prev df-carousel-control-prev bubi-img-3 '+bubi_arrow_position+' '+df_arrow_slider+' '+df_arrow_slider_table+' '+df_arrow_slider_mobile} type="button" data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide="prev" style={{left:bubi_marginarrow+'px',opacity: bubiopacityarrow}}>
                        <i className={'bubi-icon '+df_arrow_slider_type} style={{color:df_color_arrow,padding:df_padding_arrow,borderRadius:df_radius_arrow,fontSize:df_size_arrow}} aria-hidden="true"></i>
                    </a>
                    <a className={'carousel-control-next df-carousel-control-next bubi-img-3 '+bubi_arrow_position+' '+df_arrow_slider+' '+df_arrow_slider_table+' '+df_arrow_slider_mobile} type="button" data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide="next" style={{right:bubi_marginarrow+'px',opacity: bubiopacityarrow}}>
                        <i className={'bubi-icon '+df_arrow_slider_type} style={{color:df_color_arrow,padding:df_padding_arrow,borderRadius:df_radius_arrow,fontSize:df_size_arrow}} aria-hidden="true"></i>
                    </a>  
                <style>
                    {`
                        #carouselDFControlslider`+bubiblock_id_slider+`{
                            padding-left:`+bubiblock_padding_slider+`px;
                            padding-right:`+bubiblock_padding_slider+`px;
                            padding-top:`+bubiblock_padding_b_slider+`px;
                            padding-bottom:`+bubiblock_padding_b_slider+`px;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption{
                            margin-left:`+bubiblock_padding_caption+`px;
                        }
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption{
                                margin-left:`+bubiblock_padding_table_caption+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+`{
                                padding-left:`+bubiblock_padding_table_slider+`px;
                                padding-right:`+bubiblock_padding_table_slider+`px;
                                padding-top:`+bubiblock_padding_b_table_slider+`px;
                                padding-bottom:`+bubiblock_padding_b_table_slider+`px;
                            }
                        }
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption{
                                margin-left:`+bubiblock_padding_mobile_caption+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+`{
                                padding-left:`+bubiblock_padding_mobile_slider+`px;
                                padding-right:`+bubiblock_padding_mobile_slider+`px;
                                padding-top:`+bubiblock_padding_b_mobile_slider+`px;
                                padding-bottom:`+bubiblock_padding_b_mobile_slider+`px;
                            }
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .df_height_carousel_block.bubiblock_on_slider_desktopfalse{
                            display:none;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .df_height_carousel_block.bubiblock_on_slider_desktoptrue{
                            display:block;
                        }
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df_height_carousel_block.bubiblock_on_slider_tablefalse{
                                display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df_height_carousel_block.bubiblock_on_slider_tabletrue{
                                display:block;
                            }
                        }
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df_height_carousel_block.bubiblock_on_slider_mobilefalse{
                                display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df_height_carousel_block.bubiblock_on_slider_mobiletrue{
                                display:block;
                            }
                        }
                    `}
                    {bubiblock_display_button_table_caption !=1 &&
                        <>
                        {`
                            @media only screen and (max-width: 767px){
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption button{
                                   display:none;
                                }
                            }
                        `}
                        </>
                    }
                    {bubiblock_display_button_table_caption !=0 &&
                        <>
                        {`
                            @media only screen and (max-width: 767px){
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption button{
                                   display:initial;
                                }
                            }
                        `}
                        </>
                    }
                    {bubiblock_display_button_mobile_caption !=1 &&
                        <>
                        {`
                            @media only screen and (max-width: 480px){
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption button{
                                   display:none;
                                }
                            }
                        `}
                        </>
                    }
                    {bubiblock_display_button_mobile_caption !=0 &&
                        <>
                        {`
                            @media only screen and (max-width: 480px){
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-caption button{
                                   display:initial;
                                }
                            }
                        `}
                        </>
                    }
                    {df_height_slider_auto !=0 &&
                        <>
                            {`
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active{
                                    height:auto!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active img.img-cap{
                                    min-height:auto!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active video{
                                    min-height:auto!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item{
                                    height:auto!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item img.img-cap{
                                    min-height:auto!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item video{
                                    min-height:auto!important;
                                }
                            `}
                        </>
                    }
                    {df_height_slider_auto !=1 &&
                        <>
                            {`
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active,.bubiblock-color-slider-item{
                                    height:`+height_slider+`px!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active img.img-cap{
                                    min-height:`+height_slider+`px!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active video{
                                    min-height:`+height_slider+`px!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item{
                                    height:`+height_slider+`px!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item img.img-cap{
                                    min-height:`+height_slider+`px!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item video{
                                    min-height:`+height_slider+`px!important;
                                }
                                @media only screen and (max-width: 767px){
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active{
                                        height:`+height_slider_table+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one.active img.img-cap{
                                    min-height:`+height_slider_table+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one.active video{
                                    min-height:`+height_slider_table+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one{
                                    height:`+height_slider_table+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one img.img-cap{
                                    min-height:`+height_slider_table+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one video{
                                    min-height:`+height_slider_table+`px!important;
                                    }
                                }
                                @media only screen and (max-width: 480px){
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active{
                                    height:`+height_slider_mobile+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one.active img.img-cap{
                                    min-height:`+height_slider_mobile+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.one.active video{
                                    min-height:`+height_slider_mobile+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item{
                                    height:`+height_slider_mobile+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item img.img-cap{
                                    min-height:`+height_slider_mobile+`px!important;
                                    }
                                    #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item video{
                                    min-height:`+height_slider_mobile+`px!important;
                                    }
                                }
                            `}
                        </>
                    }
                    {bubiblock_full_slider !=0 &&
                    <>
                        {`
                        #carouselDFControlslider`+bubiblock_id_slider+`{
                            width: 100vw;
                            max-width: initial;
                            position: relative;
                            left: 50%;
                            right: 50%;
                            margin-left: -50vw;
                            margin-right: -50vw
                        }
                        `}
                    </>
                    }                                                                                                                                                           
                    { bubiblock_height_dot_active_enable &&
                        <>
                        {`
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-indicators li.active::after{
                            height:`+bubiblock_height_dot_active+`px;
                            background-color:`+df_color_dot+`;
                        }
                        `}
                        </>
                    }
                    {`
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-indicators.difftrue li.active::after{
                            height:`+bubiblock_height_dot_active+`px;
                            width: 100%;
                            position: absolute; 
                            transition: height .25s ease-in-out;
                            bottom: 0;
                            background-color:`+df_color_dot+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-indicators.difftrue li{
                            transition:height .25s ease-in-out;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-indicators.progtrue li.active::after{
                            width: 100%!important;
                            transition: width `+df_interval_slider+`ms ease-out;
                            top: 0;
                            height:`+df_height_dot+`px;
                            background-color:`+df_color_progress_dot+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-indicators.progtrue li::after{
                            width:0!important;
                            transition: width `+df_interval_slider+`ms ease-in;
                            position: absolute;
                            top: 0; 
                            height:`+df_height_dot+`px;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .bubiblock-block{
                            padding-left:`+bubiblock_padding_block_slider+`px;
                            padding-right:`+bubiblock_padding_block_slider+`px;
                            padding-top:`+bubiblock_padding_b_block_slider+`px;
                            padding-bottom:`+bubiblock_padding_b_block_slider+`px;
                        }
                        `}
                        { bubiblock_typography_custom &&
                        <>
                        {`
                        #carouselDFControlslider`+bubiblock_id_slider+` h4{
                            font-family:`+bubiblcok_fontfamily+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` h4{
                            font-weight:`+bubiblcok_fontfamily_weight+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` h4{
                            line-height:`+bubiblock_line_height_title+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` p{
                            font-family:`+bubiblcok_fontfamily_descritpion+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` p{
                            font-weight:`+bubiblcok_fontfamily_weight_description+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` p.bubiblock-p-capt{
                            line-height:`+bubiblock_line_height_info+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` button p{
                            font-family:`+bubiblcok_fontfamily_button+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` button p{
                            font-weight:`+bubiblcok_fontfamily_weight_button+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` button a{
                            font-family:`+bubiblcok_fontfamily_button+`;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` button a{
                            font-weight:`+bubiblcok_fontfamily_weight_button+`;
                        }
                        `}
                        </>
                        }
                        {`
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item img.img-cap,#carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .bubiblock-color-slider-item,#carouselDFControlslider`+bubiblock_id_slider+` .carousel-item video,#carouselDFControlslider`+bubiblock_id_slider+`,#carouselDFControlslider`+bubiblock_id_slider+` .carousel-item iframe{
                            border-radius:`+bubiblock_radius_slider+`%;
                        }
                        .carousel-control-next.df-carousel-control-next:hover,.carousel-control-prev.df-carousel-control-prev:hover{
                            opacity: `+bubiopacityhoverarrow+`!important;
                        }                        
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-prev i,#carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-next i{
                                font-size:`+df_size_arrow_table+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .bubiblock-block{
                                padding-left:`+bubiblock_padding_block_slider_table+`px;
                                padding-right:`+bubiblock_padding_block_slider_table+`px;
                                padding-top:`+bubiblock_padding_b_block_slider_table+`px;
                                padding-bottom:`+bubiblock_padding_b_block_slider_table+`px;
                            }
                        }
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-prev i,.df-carousel-control-next i{
                                font-size:`+df_size_arrow_mobile+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .bubiblock-block{
                                padding-left:`+bubiblock_padding_block_slider_mobile+`px;
                                padding-right:`+bubiblock_padding_block_slider_mobile+`px;
                                padding-top:`+bubiblock_padding_b_block_slider_mobile+`px;
                                padding-bottom:`+bubiblock_padding_b_block_slider_mobile+`px;
                            }
                        }
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title{
                                bottom:`+ margin_bottom_table_caption1+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info{
                                bottom:`+ margin_bottom_table_info1+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1{
                                bottom:`+ margin_bottom_table_button1+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title{
                                font-size:`+fontsizetitle1table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info{
                                font-size:`+fontsizeinfo1table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider p{
                                font-size:`+fontsizebutton1table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_2{
                                bottom:`+ margin_bottom_table_caption2+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_2{
                                bottom:`+ margin_bottom_table_info2+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2{
                                bottom:`+ margin_bottom_table_button2+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_2{
                                font-size:`+fontsizetitle2table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_2{
                                font-size:`+fontsizeinfo2table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider2 p{
                                font-size:`+fontsizebutton2table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_3{
                                bottom:`+ margin_bottom_table_caption3+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_3{
                                bottom:`+ margin_bottom_table_info3+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3{
                                bottom:`+ margin_bottom_table_button3+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_3{
                                font-size:`+fontsizetitle3table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_3{
                                font-size:`+fontsizeinfo3table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider3 p{
                                font-size:`+fontsizebutton3table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_4{
                                bottom:`+ margin_bottom_table_caption4+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_4{
                                bottom:`+ margin_bottom_table_info4+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4{
                                bottom:`+ margin_bottom_table_button4+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_4{
                                font-size:`+fontsizetitle4table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_4{
                                font-size:`+fontsizeinfo4table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider4 p{
                                font-size:`+fontsizebutton4table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_5{
                                bottom:`+ margin_bottom_table_caption5+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_5{
                                bottom:`+ margin_bottom_table_info5+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5{
                                bottom:`+ margin_bottom_table_button5+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_5{
                                font-size:`+fontsizetitle5table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_5{
                                font-size:`+fontsizeinfo5table +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider5 p{
                                font-size:`+fontsizebutton5table +`px!important;
                            }
                        }
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title{
                                bottom:`+ margin_bottom_mobile_caption1+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info{
                                bottom:`+ margin_bottom_mobile_info1+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1{
                                bottom:`+ margin_bottom_mobile_button1+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title{
                                font-size:`+fontsizetitle1mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info{
                                font-size:`+fontsizeinfo1mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider p{
                                font-size:`+fontsizebutton1mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_2{
                                bottom:`+ margin_bottom_mobile_caption2+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_2{
                                bottom:`+ margin_bottom_mobile_info2+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2{
                                bottom:`+ margin_bottom_mobile_button2+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_2{
                                font-size:`+fontsizetitle2mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_2{
                                font-size:`+fontsizeinfo2mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider2 p{
                                font-size:`+fontsizebutton2mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_3{
                                bottom:`+ margin_bottom_mobile_caption3+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_3{
                                bottom:`+ margin_bottom_mobile_info3+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3{
                                bottom:`+ margin_bottom_mobile_button3+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_3{
                                font-size:`+fontsizetitle3mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_3{
                                font-size:`+fontsizeinfo3mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider3 p{
                                font-size:`+fontsizebutton3mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_4{
                                bottom:`+ margin_bottom_mobile_caption4+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_4{
                                bottom:`+ margin_bottom_mobile_info4+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4{
                                bottom:`+ margin_bottom_mobile_button4+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_4{
                                font-size:`+fontsizetitle4mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_4{
                                font-size:`+fontsizeinfo4mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider4 p{
                                font-size:`+fontsizebutton4mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_5{
                                bottom:`+ margin_bottom_mobile_caption5+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_5{
                                bottom:`+ margin_bottom_mobile_info5+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5{
                                bottom:`+ margin_bottom_mobile_button5+`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` h4.wp-block-bubiblock-slider-slider__title_5{
                                font-size:`+fontsizetitle5mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` p.wp-block-bubiblock-slider-slider__info_5{
                                font-size:`+fontsizeinfo5mobile +`px!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .button-slider5 p{
                                font-size:`+fontsizebutton5mobile +`px!important;
                            }
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.bubiblock-flip{
                            transition: `+bubiblock_speed_flip_slider+`s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                            -webkit-transition: `+bubiblock_speed_flip_slider+`s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                            transform-style: preserve-3d;
                            -webkit-style: preserve-3d;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-prev.df-arrow-false{
                            display:none;
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-next.df-arrow-false{
                            display:none;
                        }
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-prev.df-arrow-table-false{
                            display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-next.df-arrow-table-false{
                            display:none;
                            }
                        }
                    
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-prev.df-arrow-mobile-false{
                            display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-carousel-control-next.df-arrow-mobile-false{
                            display:none;
                            }
                        }
                        #carouselDFControlslider`+bubiblock_id_slider+` .df-dot-false.carousel-indicators{
                            display:none;
                        }
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-dot-table-false.carousel-indicators{
                            display:none;
                            }
                        }
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-dot-mobile-false.carousel-indicators{
                            display:none!important;
                            }
                        }
                        @media only screen and (max-width: 767px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title.df-caption-table-false,.wp-block-bubiblock-slider-slider__info.df-caption-table-false,.link-button-1.df-caption-table-false{
                            display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-1{
                                height:`+df_height_table_divide_1 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-bottom-1{
                                height:`+df_height_table_divide_bottom_1 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_2.df-caption-table-false,.wp-block-bubiblock-slider-slider__info_2.df-caption-table-false,.link-button-2.df-caption-table-false{
                                display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-2{
                                height:`+df_height_table_divide_2 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-bottom-2{
                                height:`+df_height_table_divide_bottom_2 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_3.df-caption-table-false,.wp-block-bubiblock-slider-slider__info_3.df-caption-table-false,.link-button-3.df-caption-table-false{
                                display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-3{
                                height:`+df_height_table_divide_3 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-bottom-3{
                                height:`+df_height_table_divide_bottom_3 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_4.df-caption-table-false,.wp-block-bubiblock-slider-slider__info_4.df-caption-table-false,.link-button-4.df-caption-table-false{
                                display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-4{
                                height:`+df_height_table_divide_4 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-bottom-4{
                                height:`+df_height_table_divide_bottom_4 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_5.df-caption-table-false,.wp-block-bubiblock-slider-slider__info_5.df-caption-table-false,.link-button-5.df-caption-table-false{
                                display:none;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-5{
                                height:`+df_height_table_divide_5 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item .df-divide-bottom-5{
                                height:`+df_height_table_divide_bottom_5 +`px;
                            }
                        }
                        @media only screen and (max-width: 480px){
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title.df-caption-mobile-false,.wp-block-bubiblock-slider-slider__info.df-caption-mobile-false,.link-button-1.df-caption-mobile-false{
                            display:none!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-1{
                                height:`+df_height_mobile_divide_1 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-bottom-1{
                                height:`+df_height_mobile_divide_bottom_1 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_2.df-caption-mobile-false,.wp-block-bubiblock-slider-slider__info_2.df-caption-mobile-false,.link-button-2.df-caption-mobile-false{
                                display:none!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-2{
                                height:`+df_height_mobile_divide_2 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-bottom-2{
                                height:`+df_height_mobile_divide_bottom_2 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_3.df-caption-mobile-false,.wp-block-bubiblock-slider-slider__info_3.df-caption-mobile-false,.link-button-3.df-caption-mobile-false{
                                display:none!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-3{
                                    height:`+df_height_mobile_divide_3 +`px;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-bottom-3{
                                    height:`+df_height_mobile_divide_bottom_3 +`px;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_4.df-caption-mobile-false,.wp-block-bubiblock-slider-slider__info_4.df-caption-mobile-false,.link-button-4.df-caption-mobile-false{
                                    display:none!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-4{
                                    height:`+df_height_mobile_divide_4 +`px;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-bottom-4{
                                    height:`+df_height_mobile_divide_bottom_4 +`px;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .wp-block-bubiblock-slider-slider__title_5.df-caption-mobile-false,.wp-block-bubiblock-slider-slider__info_5.df-caption-mobile-false,.link-button-5.df-caption-mobile-false{
                                    display:none!important;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-5{
                                    height:`+df_height_mobile_divide_5 +`px;
                                }
                                #carouselDFControlslider`+bubiblock_id_slider+` .carousel-inner .carousel-item .df-divide-bottom-5{
                                    height:`+df_height_mobile_divide_bottom_5 +`px;
                                }
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider:hover{
                                background-color:`+df_background_color_hover_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider:hover{
                                background:`+df_background_color_hover_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider:hover p{
                                color:`+df_color_hover_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider:hover span{
                                color:`+df_color_hover_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider:hover a{
                                color:`+df_color_hover_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1 a{
                                color:`+df_color_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1 span{
                                color:`+df_color_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2 a{
                                color:`+df_color_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2 span{
                                color:`+df_color_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3 a{
                                color:`+df_color_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3 span{
                                color:`+df_color_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4 a{
                                color:`+df_color_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4 span{
                                color:`+df_color_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5 a{
                                color:`+df_color_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5 span{
                                color:`+df_color_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1 button.button-slider.df-trasparent-color-button1-true{
                                background-color:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1 button.button-slider.df-trasparent-color-button1-true{
                                background:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1 button.button-slider.df-trasparent-color-button1-true{
                                background-image:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-1 button.button-slider.df-trasparent-color-button1-true:hover{
                                background-color:`+df_background_color_hover_link_button1 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-1{
                                height:`+df_height_divide_1 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-1{
                                transition: max-height `+bubiblock_dalay_divide_1+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-1{
                                transition: max-height `+bubiblock_dalay_divide_1+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-1{
                                height:`+df_height_divide_bottom_1+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-bottom-1{
                                transition: max-height `+bubiblock_dalay_divide_1_bottom+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-1{
                                transition: max-height `+bubiblock_dalay_divide_1_bottom+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider2:hover{
                                background-color:`+df_background_color_hover_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider2:hover{
                                background:`+df_background_color_hover_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider2:hover p{
                                color:`+df_color_hover_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider2:hover span{
                                color:`+df_color_hover_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider2:hover a{
                                color:`+df_color_hover_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2 button.button-slider2.df-trasparent-color-button2-true{
                                background-color:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2 button.button-slider2.df-trasparent-color-button2-true{
                                background-image:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2 button.button-slider2.df-trasparent-color-button2-true{
                                background:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-2 button.button-slider2.df-trasparent-color-button2-true:hover{
                                background-color:`+df_background_color_hover_link_button2 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-2{
                                height:`+df_height_divide_2 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-2{
                                transition: max-height `+bubiblock_dalay_divide_2+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-2{
                                transition: max-height `+bubiblock_dalay_divide_2+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-2{
                                height:`+df_height_divide_bottom_2+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-bottom-2{
                                transition: max-height `+bubiblock_dalay_divide_2_bottom+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-2{
                                transition: max-height `+bubiblock_dalay_divide_2_bottom+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider3:hover{
                                background-color:`+df_background_color_hover_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider3:hover{
                                background:`+df_background_color_hover_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider3:hover p{
                                color:`+df_color_hover_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider3:hover span{
                                color:`+df_color_hover_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider3:hover a{
                                color:`+df_color_hover_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3 button.button-slider3.df-trasparent-color-button3-true{
                                background-color:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3 button.button-slider3.df-trasparent-color-button3-true{
                                background-image:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3 button.button-slider3.df-trasparent-color-button3-true{
                                background:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-3 button.button-slider3.df-trasparent-color-button3-true:hover{
                                background-color:`+df_background_color_hover_link_button3 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-3{
                                height:`+df_height_divide_3 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-3{
                                transition: max-height `+bubiblock_dalay_divide_3+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-3{
                                transition: max-height `+bubiblock_dalay_divide_3+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-3{
                                height:`+df_height_divide_bottom_3+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-bottom-3{
                                transition: max-height `+bubiblock_dalay_divide_3_bottom+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-3{
                                transition: max-height `+bubiblock_dalay_divide_3_bottom+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider4:hover{
                                background-color:`+df_background_color_hover_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider4:hover{
                                background:`+df_background_color_hover_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slide4:hover p{
                                color:`+df_color_hover_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider4:hover span{
                                color:`+df_color_hover_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider4:hover a{
                                color:`+df_color_hover_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4 button.button-slider4.df-trasparent-color-button4-true{
                                background-color:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4 button.button-slider4.df-trasparent-color-button4-true{
                                background-image:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4 button.button-slider4.df-trasparent-color-button4-true{
                                background:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-4 button.button-slider4.df-trasparent-color-button4-true:hover{
                                background-color:`+df_background_color_hover_link_button4 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-4{
                                height:`+df_height_divide_4 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-4{
                                transition: max-height `+bubiblock_dalay_divide_4+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-4{
                                transition: max-height `+bubiblock_dalay_divide_4+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-4{
                                height:`+df_height_divide_bottom_4+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-bottom-4{
                                transition: max-height `+bubiblock_dalay_divide_4_bottom+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-4{
                                transition: max-height `+bubiblock_dalay_divide_4_bottom+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider5:hover{
                                background-color:`+df_background_color_hover_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider5:hover{
                                background:`+df_background_color_hover_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slide5:hover p{
                                color:`+df_color_hover_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider5:hover span{
                                color:`+df_color_hover_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` button.button-slider5:hover a{
                                color:`+df_color_hover_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5 button.button-slider5.df-trasparent-color-button5-true{
                                background-color:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5 button.button-slider5.df-trasparent-color-button5-true{
                                background-image:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5 button.button-slider5.df-trasparent-color-button5-true{
                                background:transparent!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .link-button-5 button.button-slider5.df-trasparent-color-button5-true:hover{
                                background-color:`+df_background_color_hover_link_button5 +`!important;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-5{
                                height:`+df_height_divide_5 +`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-5{
                                transition: max-height `+bubiblock_dalay_divide_5+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-5{
                                transition: max-height `+bubiblock_dalay_divide_5+`s ease-out;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-5{
                                height:`+df_height_divide_bottom_5+`px;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .carousel-item.active .df-divide-bottom-5{
                                transition: max-height `+bubiblock_dalay_divide_5_bottom+`s ease-in;
                            }
                            #carouselDFControlslider`+bubiblock_id_slider+` .df-divide-bottom-5{
                                transition: max-height `+bubiblock_dalay_divide_5_bottom+`s ease-out;
                            }
                    `}
                </style>
            </div>
        )
    },
     //Preview
	example: () => {
    }, 
    edit
});